import { createRouter, createWebHistory } from 'vue-router';

import SingleLayout from '@/layout/SingleLayout.vue';
import AppLayout from '@/layout/AppLayout.vue';

import E404Page from '@/page/E404Page.vue';
import LoginPage from '@/page/LoginPage.vue';

import Auth from '@/service/auth.js';
import Token from '@/utils/Token';

// Lazy-loaded pages (code splitting)
const EsqueciSenhaPage = () => import('@/page/EsqueciSenhaPage.vue');
const AlterarSenhaPage = () => import('@/page/AlterarSenhaPage.vue');

// Dashboard
const DashboardPage = () => import('@/page/dashboard/DashboardPage.vue');
const KanbanPage = () => import('@/page/dashboard/KanbanPage.vue');
const KpiPage = () => import('@/page/dashboard/KpiPage.vue');
const MapaPage = () => import('@/page/dashboard/MapaPage.vue');
const KpiEquipePage = () => import('@/page/dashboard/KpiEquipePage.vue');
const KpiPrevisaoPage = () => import('@/page/dashboard/KpiPrevisaoPage.vue');
const ControlePage = () => import('@/page/dashboard/ControlePage.vue');
const DashboardExecutivoPage = () => import('@/page/dashboard/DashboardExecutivoPage.vue');
const KpiSchedulePage = () => import('@/page/dashboard/KpiSchedulePage.vue');
const KpiPendenciaPage = () => import('@/page/dashboard/KpiPendenciaPage.vue');
const MinhaCaixaPage = () => import('@/page/dashboard/MinhaCaixaPage.vue');

// Operacoes
const SiteListaPage = () => import('@/page/site/ListaPage.vue');
const ImportPage = () => import('@/page/site/ImportPage.vue');
const PendenciaListaPage = () => import('@/page/pendencia/ListaPage.vue');
const EquipeListaPage = () => import('@/page/equipe/ListaPage.vue');
const RelatorioListaPage = () => import('@/page/relatorio/ListaPage.vue');
const BaseListaPage = () => import('@/page/base/ListaPage.vue');

// Admin
const ConfiguracaoPage = () => import('@/page/admin/ConfiguracaoPage.vue');
const ProjetoListaPage = () => import('@/page/projeto/ListaPage.vue');
const FaseListaPage = () => import('@/page/fase/ListaPage.vue');
const FluxoPage = () => import('@/page/fase/FluxoPage.vue');
const UsuarioListaPage = () => import('@/page/usuario/ListaPage.vue');
const PerfilListaPage = () => import('@/page/perfil/ListaPage.vue');
const LogListaPage = () => import('@/page/log/ListaPage.vue');
const LogAcessoListaPage = () => import('@/page/logAcesso/ListaPage.vue');
const CidadeListaPage = () => import('@/page/cidade/ListaPage.vue');
const EstadoListaPage = () => import('@/page/estado/ListaPage.vue');


const routes = [
    {
        path: '',
        component: SingleLayout,
        beforeEnter: (to, from, next) => {
            if(Token.isAuthenticated()) {
                return next({ name: 'dashboard'});
            }
            permissoes = {};
            return next();
        },
        children: [
            { path: ':catchAll(.*)', component: E404Page, },
            { path: '', redirect: { name: 'login' } },
            { path: '/login', component: LoginPage, name: 'login' },
            { path: '/esqueci-senha', component: EsqueciSenhaPage, name: 'esqueci-senha' },
            { path: '/alterar-senha/:token', component: AlterarSenhaPage, name: 'alterar-senha' },
        ],
    },
    {
        path: '/app',
        component: AppLayout,
        beforeEnter: (to, from, next) => {
            if(!Token.isAuthenticated()) {
                return next({ name: 'login', query: {error:'auth'} });
            }

            if (Object.keys(permissoes).length === 0) {
                Auth.permissoes()
                    .then(response => {
                        permissoes = response.data;
                        const event = new Event("onPermissios");
                        event.permissoes = permissoes;
                        document.dispatchEvent(event);
                    })
                    .catch(() => {
                        // Sessao invalida no servidor (cookie expirado)
                        Token.remove();
                        return next({ name: 'login', query: {error:'auth'} });
                    });
            }
            return next();
        },

        children: [
            { path: ':catchAll(.*)', component: E404Page, },
            { path: '', redirect: { name: 'dashboard' } },

            // Dashboard
            { path: 'dashboard', component: DashboardPage, name: 'dashboard' },
            { path: 'kanban', component: KanbanPage, name: 'kanban' },
            { path: 'kpi', component: KpiPage, name: 'kpi' },
            { path: 'mapa', component: MapaPage, name: 'mapa' },
            { path: 'kpi-equipe', component: KpiEquipePage, name: 'kpi-equipe' },
            { path: 'kpi-previsao', component: KpiPrevisaoPage, name: 'kpi-previsao' },
            { path: 'controle', component: ControlePage, name: 'controle' },
            { path: 'pmo', component: DashboardExecutivoPage, name: 'pmo' },
            { path: 'kpi-schedule', component: KpiSchedulePage, name: 'kpi-schedule' },
            { path: 'kpi-pendencias', component: KpiPendenciaPage, name: 'kpi-pendencias' },
            { path: 'minha-caixa', component: MinhaCaixaPage, name: 'minha-caixa' },

            // Operacoes
            { path: 'pendencias', component: PendenciaListaPage, name: 'pendencia.lista' },
            { path: 'sites', component: SiteListaPage, name: 'site.lista' },
            { path: 'site/importar', component: ImportPage, name: 'site.importar' },
            { path: 'equipes', component: EquipeListaPage, name: 'equipe.lista' },
            { path: 'relatorios', component: RelatorioListaPage, name: 'relatorio.lista' },
            { path: 'bases', component: BaseListaPage, name: 'base.lista' },

            // Administracao
            { path: 'projetos', component: ProjetoListaPage, name: 'projeto.lista' },
            { path: 'fases', component: FaseListaPage, name: 'fase.lista' },
            { path: 'fluxo', component: FluxoPage, name: 'fluxo' },
            { path: 'usuarios', component: UsuarioListaPage, name: 'usuario.lista' },
            { path: 'perfis', component: PerfilListaPage, name: 'perfil.lista' },
            { path: 'logs', component: LogListaPage, name: 'log.lista' },
            { path: 'logs-acesso', component: LogAcessoListaPage, name: 'log-acesso.lista' },
            { path: 'estados', component: EstadoListaPage, name: 'estado.lista' },
            { path: 'cidades', component: CidadeListaPage, name: 'cidade.lista' },
            { path: 'configuracoes', component: ConfiguracaoPage, name: 'configuracao.lista' },
        ]
    },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
